import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M16.0625 0C16.3125 0 16.625 0.125 16.875 0.1875L28.625 5.1875C30 5.8125 31.0625 7.125 31.0625 8.75C31 15 28.4375 26.3125 17.6875 31.5C16.625 32 15.4375 32 14.375 31.5C3.625 26.3125 1.0625 15 1 8.75C1 7.125 2.0625 5.8125 3.4375 5.1875L15.1875 0.1875C15.4375 0.125 15.75 0 16.0625 0ZM16.0625 27.8125C24.625 23.625 27 14.4375 27.0625 8.875L16.0625 4.1875V27.8125Z'],
  name: 'uiShieldHalf',
  oldName: 'fasShieldHalf'
} as IconDefinition
